document.addEventListener("DOMContentLoaded", () => {
  // Update price of product card when variant is changed
  document.querySelectorAll(".product-card").forEach((productCard) => {
    productCard
      .querySelector(".product-card__variant-selector")
      ?.addEventListener("change", (e) => {
        // Update button with variant price
        const variantPrice =
          e.target.options[e.target.selectedIndex].dataset.price;
        if (variantPrice) {
          productCard.querySelector(
            ".product-card__buy-button-price-span"
          ).innerHTML = variantPrice;
        }
        // Update button with variant compare at price
        const variantCompareAtPrice =
          e.target.options[e.target.selectedIndex].dataset.compare_at_price;
        if (variantCompareAtPrice) {
          productCard.querySelector(
            ".product-card__buy-button-compare-at-price-span"
          ).innerHTML = variantCompareAtPrice;
        }
      });
  });

  // js/common/product/product-gallery-savings-tag.js
  class ProductGallerySavingsTag extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productRerender = document.querySelector("product-rerender");
      if (!this.productRerender) return;

      this.productRerender.addEventListener(
        "variant:change",
        this.onVariantChange
      );
    }

    onVariantChange = () => {
      const savings = this.productRerender.querySelector(
        ".price-list__savings"
      )?.textContent;
      this.textContent = savings ?? "";
    };

    disconnectedCallback() {
      this.productRerender?.removeEventListener(
        "variant:change",
        this.onVariantChange
      );
    }
  }

  customElements.define(
    "product-gallery-savings-tag",
    ProductGallerySavingsTag
  );

  // ---------------------------------------------------------------
  // VÉRIFICATION D'ÂGE AU PANIER (exigence Mollie)
  // Tant que la case n'est pas cochée : bouton « Commander » désactivé et
  // boutons de paiement express masqués. Sans ce second point, Shop Pay ou
  // PayPal enverraient droit au paiement en sautant la case.
  // Délégation + réapplication sur cart:change : le tiroir est re-rendu à
  // chaque modification du panier, un écouteur direct serait perdu.
  // ---------------------------------------------------------------
  const ageCoche = () =>
    !!document.querySelector("[data-myc-age-input]:checked");

  const appliquerAge = () => {
    const ok = ageCoche();

    document.querySelectorAll("[data-myc-age-input]").forEach((input) => {
      if (input.checked !== ok) input.checked = ok;
    });

    document
      .querySelectorAll('[name="checkout"], .cart-drawer__checkout-button')
      .forEach((bouton) => {
        bouton.disabled = !ok;
        bouton.setAttribute("aria-disabled", String(!ok));
        bouton.classList.toggle("myc-age-bloque", !ok);
      });

    document
      .querySelectorAll(
        ".additional-checkout-buttons, [data-shopify='dynamic-checkout-cart'], .shopify-payment-button"
      )
      .forEach((zone) => {
        zone.classList.toggle("myc-age-masque", !ok);
      });

    document.querySelectorAll("[data-myc-age]").forEach((bloc) => {
      bloc.classList.toggle("myc-age--valide", ok);
    });
  };

  document.addEventListener("change", (event) => {
    if (event.target.closest("[data-myc-age-input]")) appliquerAge();
  });

  // Clic sur un bouton désactivé : on attire l'œil sur la case au lieu de
  // laisser le client devant un bouton mort.
  document.addEventListener(
    "click",
    (event) => {
      const bloque = event.target.closest(".myc-age-bloque");
      if (!bloque || ageCoche()) return;
      const bloc = (
        bloque.closest("form, .cart-drawer, .cart") || document
      ).querySelector("[data-myc-age]");
      if (!bloc) return;
      bloc.classList.remove("myc-age--attire");
      void bloc.offsetWidth;
      bloc.classList.add("myc-age--attire");
      bloc.scrollIntoView({ block: "nearest", behavior: "smooth" });
    },
    true
  );

  document.addEventListener("cart:change", () => setTimeout(appliquerAge, 60));
  document.addEventListener("cart:refresh", () => setTimeout(appliquerAge, 60));
  document.addEventListener("variant:add", () => setTimeout(appliquerAge, 60));
  new MutationObserver(() => appliquerAge()).observe(document.body, {
    childList: true,
    subtree: true,
  });
  appliquerAge();

  // Gorgias (chat + campagnes + formulaires) : ~600 Ko de scripts qui
  // plombaient le Speed Index. L'app embed est désactivé dans l'éditeur ;
  // on recharge ses 3 scripts officiels au PREMIER geste du visiteur
  // (défilement, clic, touche, tap). Un visiteur qui n'interagit jamais
  // n'aurait jamais ouvert le chat de toute façon.
  (() => {
    let gorgiasCharge = false;
    const chargerGorgias = () => {
      if (gorgiasCharge) return;
      gorgiasCharge = true;
      [
        ["data-gorgias-loader-chat", "https://config.gorgias.chat/bundle-loader/shopify/my-chanvre86.myshopify.com"],
        ["data-gorgias-loader-convert", "https://content.9gtb.com/loader.js"],
        ["data-gorgias-loader-mailto-replace", "https://config.gorgias.help/api/contact-forms/replace-mailto-script.js?shopName=my-chanvre86"],
      ].forEach(([attr, src]) => {
        const script = document.createElement("script");
        script.defer = true;
        script.setAttribute(attr, "");
        script.src = src;
        document.head.appendChild(script);
      });
      ["pointerdown", "keydown", "wheel", "touchstart", "scroll"].forEach((t) =>
        removeEventListener(t, chargerGorgias)
      );
    };
    ["pointerdown", "keydown", "wheel", "touchstart", "scroll"].forEach((t) =>
      addEventListener(t, chargerGorgias, { passive: true, once: false })
    );
  })();

  // Le badge d'avis (haut de fiche) descend au widget d'avis complet
  document.addEventListener("click", (event) => {
    const badge = event.target.closest(".jdgm-prev-badge");
    if (!badge || event.target.closest("a")) return;
    document
      .querySelector("#judgeme_product_reviews, .jdgm-review-widget")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  // « Ajouter au panier » dit « C'est dans le sac » pendant quelques
  // secondes après un ajout réussi (évènement variant:add du thème,
  // émis par le form : on retrouve tous les boutons qui lui sont liés,
  // bouton principal et barre collante).
  document.addEventListener("variant:add", (event) => {
    const formId = event.target?.id;
    if (!formId) return;
    const selector =
      'button[form="' + CSS.escape(formId) + '"], ' +
      "#" + CSS.escape(formId) + ' button[type="submit"]';
    [...document.querySelectorAll(selector)]
      .filter((button) => /panier/i.test(button.textContent))
      .forEach((button) => {
        if (button.dataset.mycBag) return;
        const original = button.innerHTML;
        button.dataset.mycBag = "1";
        button.innerHTML = "C'est dans le sac ✅";
        setTimeout(() => {
          button.innerHTML = original;
          delete button.dataset.mycBag;
        }, 2500);
      });
  });

  // Barre collante : le sélecteur relaie le choix vers le vrai picker.
  // Délégation obligatoire : product-rerender remplace la barre à chaque
  // changement de variante, un listener posé sur le select serait perdu.
  document.addEventListener("change", (event) => {
    const select = event.target.closest(".myc-sticky-select");
    if (!select) return;
    const radio = [
      ...document.getElementsByName(select.dataset.formId + "-option1"),
    ].find((input) => input.value === select.value);
    if (radio && !radio.checked) radio.click();
  });

  // Le format 50 g est présélectionné sur toutes les fiches, sauf quand
  // l'URL impose déjà une variante (lien partagé, carte de collection).
  // On passe par un clic sur la radio du picker : toute la mécanique du
  // thème suit (prix, galerie, barre collante, URL).
  if (!new URLSearchParams(location.search).has("variant")) {
    const picker = document.querySelector(
      'variant-picker[context="main_product"]'
    );
    if (picker) {
      const fifty = [...picker.querySelectorAll('input[type="radio"]')].find(
        (input) => {
          if (input.checked || input.disabled) return false;
          const label = picker.querySelector(
            `label[for="${CSS.escape(input.id)}"]`
          );
          return (
            label &&
            /(?:^|[^0-9])50\s*g/i.test(label.textContent.replace(/\s+/g, " "))
          );
        }
      );
      fifty?.click();
    }
  }
});

// COMPTE À REBOURS (sections/countdown.liquid)
// Les chiffres sont déjà rendus justes par Liquid au chargement, ici on ne
// fait que décompter. Sous une heure restante, la carte des secondes passe en
// surbrillance. À zéro, la section bascule sur son message de fin, et
// disparaît si le réglage « Masquer une fois l'offre terminée » est coché.
const mycInitCountdowns = (root) => {
  const scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll("[data-myc-countdown]").forEach((el) => {
    if (el.dataset.mycCountdownOn === "1") return;
    el.dataset.mycCountdownOn = "1";

    const end = Number(el.dataset.fin) * 1000;
    if (!Number.isFinite(end) || end <= 0) return;

    const cells = {};
    el.querySelectorAll("[data-cd]").forEach((node) => {
      cells[node.dataset.cd] = node;
    });
    const pad = (value) => String(value).padStart(2, "0");

    const tick = () => {
      const total = Math.max(0, Math.floor((end - Date.now()) / 1000));

      if (cells.jours) cells.jours.textContent = pad(Math.floor(total / 86400));
      if (cells.heures)
        cells.heures.textContent = pad(Math.floor((total % 86400) / 3600));
      if (cells.minutes)
        cells.minutes.textContent = pad(Math.floor((total % 3600) / 60));
      if (cells.secondes) cells.secondes.textContent = pad(total % 60);

      el.classList.toggle("cd--urgent", total > 0 && total < 3600);

      if (total > 0) return;

      el.classList.add("cd--fini");
      clearInterval(timer);
      const editeur = window.Shopify && window.Shopify.designMode;
      if (el.dataset.cdMasquer === "1" && !editeur) {
        const section = el.closest(".shopify-section") || el;
        section.style.display = "none";
      }
    };

    const timer = setInterval(tick, 1000);
    tick();
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => mycInitCountdowns());
} else {
  mycInitCountdowns();
}
// L'éditeur de thème recharge une section sans recharger la page.
document.addEventListener("shopify:section:load", (event) =>
  mycInitCountdowns(event.target)
);
